import {CompositionFont} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {compositionEditorLimits} from '../constants/compositionEditorLimits';
import {getFontFamilies} from './getFontFamilies';

export const BUILT_IN_FONT_OPTION_VALUE = 'built-in';

export const getFontOptions = (fonts: CompositionFont[]) => [
  {
    value: BUILT_IN_FONT_OPTION_VALUE,
    label: `${compositionEditorLimits.builtInFontFamily} (${i18n.t('entity.watermark.composition.labels.builtInFont')})`,
  },
  ...getFontFamilies(fonts).map((family) => ({value: family.optionValue, label: family.family})),
];
